<div class="revision-request-info-container">
  <div class="revision-request-info-item-container">
    <div class="revision-request-info-item-input-container">
      <mat-form-field appearance="outline" class="revision-request-info-form-field">
        <mat-label>Name for which you are requesting a revision</mat-label>
        <input matInput #revisionRequestNameInput [(ngModel)]="revisionRequestName" class="revision-request-info revision-request-info-item-input"
        (keyup.enter)="updateRevisionRequestName($event)" (keyup.escape)="cancelRevisionRequestNameUpdate()" (blur)="updateRevisionRequestName($event)" />
        <mat-icon matSuffix (mousedown)="clearRevisionRequestNameInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>
  
  <div class="revision-request-info-item-container">
    <div class="revision-request-info-item-input-container">
      <mat-form-field appearance="outline" class="revision-request-info-form-field">
        <mat-label>Reason for revision</mat-label>
        <textarea matInput #revisionRequestReasonInput [(ngModel)]="revisionRequestReason" class="revision-request-info revision-request-info-item-input"
        (keyup.enter)="updateRevisionRequestReason($event)" (keyup.escape)="cancelRevisionRequestReasonUpdate()" (blur)="updateRevisionRequestReason($event)"></textarea>
        <mat-icon matSuffix (mousedown)="clearRevisionRequestReasonInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <div class="revision-request-info-form-info revision-request-info-form-info-text">Please describe revisions to any of the following.</div>
</div>